import actionCreatorFactory from 'typescript-fsa';

import * as store from './store';
import * as api from '../api';

const actionCreator = actionCreatorFactory();

interface SetDocumentsAction {
  formSetId: string;
  documents: api.PrevisitDocument.DocumentWithTemplate[];
}

export const setDocuments = actionCreator<SetDocumentsAction>('SET_DOCUMENTS');
export function setDocumentsHandler(
  state: store.All,
  { formSetId, documents }: SetDocumentsAction,
): store.All {
  return {
    ...state,
    formSets: {
      ...state.formSets,
      [formSetId]: {
        ...state.formSets[formSetId],
        documents,
      },
    },
  };
}
